import { render, staticRenderFns } from "./batchNumberDetail.vue?vue&type=template&id=286790b0&scoped=true"
import script from "./batchNumberDetail.vue?vue&type=script&lang=js"
export * from "./batchNumberDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286790b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286790b0')) {
      api.createRecord('286790b0', component.options)
    } else {
      api.reload('286790b0', component.options)
    }
    module.hot.accept("./batchNumberDetail.vue?vue&type=template&id=286790b0&scoped=true", function () {
      api.rerender('286790b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/accountsPayable/cmp/batchNumberDetail.vue"
export default component.exports